export default {
  name: 'fort',
  props: {
    msg: String
  }
}